import React, { useCallback, useEffect, useState } from 'react';
import { Button, Grid, Typography, makeStyles } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { useDispatch, useSelector } from 'react-redux';
import Modal from '../common/Modal';
import EditIcon from '../../assets/SvgIonReorderTwo';
import { ErrorToast, notifySuccess } from '../utils/Utils';
import { showProgress } from '../../redux/actions/DealershipActions';
import service from '../../apis/service';
import { apiEndpoints } from '../../constants/apiEndpoints';
import useFetchData from './hooks/useFetchData';

const useStyle = makeStyles({
  popupContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  wrapper: {
    height: '70vh',
    overflowY: 'auto',
    background: '#F2F4F7',
    display: 'flex',
    flexDirection: 'column',
    gap: '15px',
    padding: '10px 20px',
  },
  inputField: {
    width: '95%',
    padding: '10px 10px',
    height: '60px',
    borderRadius: '5px',
    border: '1px solid #E4E7EC',
    outline: 'none',
    marginTop: '5px',
    background: '#FEFEFE',
  },
  takeaway: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    justifyContent: 'space-between',
  },
  container: {
    background: '#fff',
    display: 'flex',
    gap: '10xp',
    alignItems: 'center',
    width: '92%',
    padding: '10px',
    borderRadius: '5px',
  },
  msgbox: {
    width: '99%',
    position: 'relative',
  },
  addBtn: {
    padding: '5px',
    border: '2px solid #622FEE',
    height: '40px',
  },
  line: {
    width: '280px',
    height: '1px',
    background: 'grey',
  },
});

export function Takeaway({ isEdit, setShowAddTakeaways }) {
  const classes = useStyle();
  const dispatch = useDispatch();
  const { getJourneyDetail } = useFetchData();
  const journeyDetails = useSelector((state) => state.JourneyDetails.journeydetails);

  const [takeawayList, setTakeawayList] = useState(['']);

  const getTakeaways = useCallback(async () => {
    try {
      const res = await service.get(apiEndpoints.JOURNEY_TAKEAWAY_INFO.replace('ID', journeyDetails.id));
      setTakeawayList(res);
    } catch (error) {
      ErrorToast(error);
    }
  }, [journeyDetails.id]);

  useEffect(() => {
    if (isEdit) {
      getTakeaways();
    }
  }, [getTakeaways, isEdit]);

  const handleAdd = () => {
    setTakeawayList((prevList) => [...prevList, '']);
  };

  const handleRemove = (index) => {
    setTakeawayList((prevList) => {
      const newList = [...prevList];
      newList.splice(index, 1);
      return newList;
    });
  };

  const handleChange = (e, index) => {
    const newValue = e.target.value;
    if (newValue.length <= 160) {
      setTakeawayList((prevList) => {
        const newList = [...prevList];
        newList[index] = newValue;
        return newList;
      });
    }
  };

  const checkValidation = () => {
    let isValid = true;
    takeawayList.forEach((m) => {
      if (m.length === 0) {
        ErrorToast('Takeaway can not be empty');
        isValid = false;
      }
    });
    return isValid;
  };

  const handleSave = async () => {
    if (!checkValidation()) return;
    if (takeawayList.length < 2) {
      ErrorToast('Please add atleast 2 takeaways');
      return;
    }

    dispatch(showProgress(true));
    const data = {
      journeyId: journeyDetails.id,
      takeaways: takeawayList,
    };

    try {
      await service.post(apiEndpoints.JOURNEY_TAKEAWAY_CREATE, data);
      notifySuccess('Takeaways added successfully');
      getJourneyDetail(journeyDetails?.id, false);
      setShowAddTakeaways(false);
    } catch (error) {
      ErrorToast(error);
    }
    dispatch(showProgress(false));
  };
  return (
    <Modal isOpen height="84vh" width="820px">
      <Grid className={classes.popupContainer}>
        <Grid container direction="row" justifyContent="space-between" alignItems="flex-start">
          <Grid item>
            <Grid item style={{ fontWeight: '600', fontSize: '18px' }}>
              Add Takeaways
            </Grid>
          </Grid>
          <Grid item>
            <CloseIcon onClick={() => setShowAddTakeaways(false)} style={{ cursor: 'pointer' }} />
          </Grid>
        </Grid>

        <Grid className={classes.wrapper}>
          {takeawayList.map((m, i) => (
            <Grid className={classes.takeaway}>
              <Grid className={classes.container}>
                <Grid className={classes.equalIcon}>
                  <EditIcon />
                </Grid>
                <Grid className={classes.msgbox}>
                  <textarea
                    placeholder="Type takeaway here"
                    className={classes.inputField}
                    value={m}
                    onChange={(e) => handleChange(e, i)}
                  />
                  <Typography
                    variant="p"
                    style={{
                      display: 'flex',
                      justifyContent: 'flex-end',
                      width: '98%',
                      color: '#98A2B3',
                      fontSize: '14px',
                      position: 'absolute',
                      right: '20px',
                      bottom: '20px',
                    }}
                  >
                    {m.length || 0}/160
                  </Typography>
                </Grid>
              </Grid>
              <Grid item>
                {takeawayList.length > 2 ? (
                  <CloseIcon style={{ cursor: 'pointer' }} onClick={() => handleRemove(i)} />
                ) : (
                  <CloseIcon style={{ visibility: 'hidden' }} />
                )}
              </Grid>
            </Grid>
          ))}

          <Grid style={{ marginTop: '5px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <div className={classes.line} />
            <Button color="primary" className={classes.addBtn} onClick={handleAdd}>
              + Add Takeaway
            </Button>
            <div className={classes.line} />
          </Grid>
        </Grid>
        <Grid container direction="row" justifyContent="flex-end" alignItems="center">
          <>
            <Button onClick={() => setShowAddTakeaways(false)} variant="outlined">
              Cancel
            </Button>
            <Button variant="contained" color="primary" style={{ marginLeft: '10px' }} onClick={handleSave}>
              Save
            </Button>
          </>
        </Grid>
      </Grid>
    </Modal>
  );
}
